import { createAuthClient } from "better-auth/react";
import { emailOTPClient, siweClient } from "better-auth/client/plugins";
import { passkeyClient } from "@better-auth/passkey/client";
import { API_BASE_URL } from "../config";

export const authClient = createAuthClient({
  baseURL: API_BASE_URL,
  basePath: "/api/auth",
  plugins: [
    emailOTPClient(),
    passkeyClient(),
    siweClient(),
  ],
  // fetchOptions: {
  //   onSuccess: (ctx) => {
  //     const authToken = ctx.response.headers.get("set-auth-token"); // get the token from the response headers
  //     console.log("authToken", authToken, ctx);
  //     // Store the token securely (e.g., in localStorage)
  //     if (authToken) {
  //       localStorage.setItem("bearer_token", authToken);
  //     }
  //   },
  // },
});

/**
 * Obtém o token bearer do localStorage
 * @returns O token bearer ou null se não existir
 */
export function getBearerToken(): string | null {
  return localStorage.getItem("bearer_token");
}

/**
 * Remove o token bearer do localStorage
 */
export function clearBearerToken(): void {
  localStorage.removeItem("bearer_token");
}
